import { Box, Chip, Typography } from "@mui/material";
import { Icons } from "../../assets/icon";

export default function RatingNReview({
  rating,
  reviews,
  reviewIsDate = false,
}: {
  rating: string;
  reviews: string;
  reviewIsDate?: boolean;
}) {
  return (
    <Chip
      label={reviews}
      icon={
        <Box
          ml="2px"
          sx={{
            display: "flex",
            padding: "2px 8px 2px var(--spacing-1x)",
            justifyContent: "center",
            alignItems: "center",
            gap: "var(--spacing-1x)",
            borderRadius: "16px",
            background: "var(--neutralWhite)",
            color: "var(--neutral-1000)",
            font: "var(--semibold-sm)",
            marginLeft: "0px",
            "& .css-qwn5fn-MuiChip-root .MuiChip-icon": {
              marginLeft: "0px",
            },
          }}
        >
          <Icons.Rating />
          <Typography
            sx={{
              color: "var(--neutral-1000)",
              font: "var(--semibold-sm)",
              fontSize: {
                xs: "10px",
                sm: "12px",
                md: "14px",
              },
            }}
          >
            {rating}
          </Typography>
        </Box>
      }
      sx={{
        borderRadius: "16px",
        background: "var(--primary-100)",
        display: "flex",
        justifyContent: "space-between",
        padding: "2px 8px 2px var(--spacing-1x)",
        gap: "var(--spacing-1x)",
        alignItems: "center",
        height: "28px",

        "& .css-qwn5fn-MuiChip-root .MuiChip-icon": {
          marginLeft: "0px",
        },

        ...(reviewIsDate
          ? {
              color: "var(--neutral-500)",
              font: "var(--text-xs)",
              lineHeight: 2,
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }
          : {
              color: "var(--neutral-1000)",
              font: "var(--body-xs)",
              lineHeight: 2,
              fontSize: {
                xs: "10px",
                sm: "12px",
              },
            }),
      }}
    />
  );
}
